import { render, staticRenderFns } from "./talent2.vue?vue&type=template&id=6e8fe4ad&scoped=true"
import script from "./talent2.vue?vue&type=script&lang=js"
export * from "./talent2.vue?vue&type=script&lang=js"
import style0 from "./talent2.vue?vue&type=style&index=0&id=6e8fe4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8fe4ad",
  null
  
)

export default component.exports